import React = require('react')

import { IConfiguration, StoreQuoteData } from './models'
import { RepairQuote } from './RepairQuote'
import { ReplacementQuote } from './ReplacementQuote'
import { AsyncPost, find, getUniqueArray } from './utils'

interface Properties {
    configurations:   IConfiguration[]
    sendQuoteByEmail: AsyncPost<StoreQuoteData, any>
    quote:            number
}

interface Callbacks {
    onQuoteAccepted:       () => void     // Triggered when the user accepts the quote
    onReplacementAccepted: () => void     // Triggered when the user accepts device replacement
    onEmailQuote:          () => void        // Triggered when the user selects to receive the quote on email
}

interface Props extends Properties, Callbacks {}

interface State {
}

export class Quote extends React.Component<Props, State> {
    render() {
        const [device, model, color, capacity] = this.props.configurations[0].configuration

        const CAPACITY_CONFIGURATION_INDEX = 3
        const replacementPrices = getUniqueArray(
                this.props.configurations
                    .filter(x => x.replacementPrice)
                    .map(x => x.configuration[CAPACITY_CONFIGURATION_INDEX])
                )
            .map(capacity => {
                const configuration = find(this.props.configurations, x => x.configuration[CAPACITY_CONFIGURATION_INDEX] === capacity)
                return {
                    capacity:         configuration.configuration[CAPACITY_CONFIGURATION_INDEX],
                    replacementPrice: configuration.replacementPrice
                }
            })

        return (
            <div className="cc-quote">
                <RepairQuote
                    quote={this.props.quote}
                    sendQuoteByEmail={this.props.sendQuoteByEmail}
                    handleEmailQuoteBtnClick={this.props.onEmailQuote}
                    handleAcceptBtnClick={this.props.onQuoteAccepted}
                />
                {
                    replacementPrices.length > 0 &&
                    <div className="cc-quote__or-text">
                        Don’t want to repair it? Get a replacement instead.
                    </div>
                }
                {
                    replacementPrices.length > 0 &&
                    <ReplacementQuote
                        device={device}
                        model={model}
                        capacity={capacity}
                        replacementPrices={replacementPrices}
                        handleReplacementAcceptBtnClick={this.props.onReplacementAccepted}
                    />
                }
            </div>
        )
    }
}
